import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {baseSetValue} from '../../utils';
import {CastSessionState, CastSliceState} from './types';

const initialState: CastSliceState = {
    available: false,
    state: 'idle',
    position: 0,
};

export const reducers = createSlice({
    name: 'cast',
    initialState,
    reducers: {
        setValue: baseSetValue<CastSliceState>(),
        setSession: (
            state,
            action: PayloadAction<{ state: CastSessionState; deviceName?: string }>,
        ) => {
            state.state = action.payload.state;
            state.deviceName = action.payload.deviceName;
            // Position is only meaningful while connected; clear on terminal states
            // so the next session starts at zero instead of leaking the last value.
            if (action.payload.state === 'idle' || action.payload.state === 'ended' || action.payload.state === 'failed') {
                state.position = 0;
                state.deviceName = undefined;
            }
        },
    },
});

export const {setValue, setSession} = reducers.actions;
export default reducers.reducer;
